<div class="container">
  <h2 mat-dialog-title class="title">Schreiben Sie den Empfänger, Ihre Nachricht und Datum, bis wann die unverbindliche Anfrage bearbeitet werden sollte, hier ein:</h2>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="messageCreationFormGroup" class="main">
      <div class="field-content">
        <h4>An</h4>
        <mat-form-field appearance="outline"
                        [class.mat-form-field-invalid]="messageCreationFormGroup.get('assignedTo')?.invalid && (messageCreationFormGroup.get('assignedTo')?.dirty || messageCreationFormGroup.get('assignedTo')?.touched)">
          <mat-label>Empfänger (kann auch man selbst sein)</mat-label>
          <mat-chip-grid
            #usersChipList
            aria-label="Emails"
            required
            [errorStateMatcher]="matcher">
            <mat-chip-row
              *ngFor="let user of selectedUsers; let i = index"
              removable="true"
              (removed)="onUserRemove(i)">
              {{ user.firstname }} {{ user.lastname }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
              name="emails"
              formControlName="userName"
              matInput
              #usersInput
              [matChipInputFor]="usersChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              [matAutocomplete]="userNameAutoOption"
              [errorStateMatcher]="matcher">
          </mat-chip-grid>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
          <mat-autocomplete #userNameAutoOption (optionSelected)="onUserSelected($event)">
            <mat-option *ngFor="let user of autocompleteUser$ | async"
                        [class.internalUser]="this.isUserInternal(user)"
                        [class.externalUser]="!this.isUserInternal(user)"
                        [value]="user">
              {{this.isUserInternal(user) ? '(Operator)' : '(Extern)'}} - {{ user.firstname }} {{ user.lastname }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-content">
        <h4>CC</h4>
        <mat-form-field appearance="outline"
                        [class.mat-form-field-invalid]="messageCreationFormGroup.get('recipientsCC')?.invalid && (messageCreationFormGroup.get('recipientsCC')?.dirty || messageCreationFormGroup.get('recipientsCC')?.touched)">
          <mat-label>Empfänger (kann auch man selbst sein)</mat-label>
          <mat-chip-grid
            #recipientsCCChipList
            aria-label="EmailsCC"
            [errorStateMatcher]="matcher">
            <mat-chip-row
              *ngFor="let user of selectedUsersCC; let i = index"
              removable="true"
              (removed)="onUserCCRemove(i)">
              {{ user.firstname }} {{ user.lastname }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
              name="emailsCC"
              formControlName="recipientCC"
              matInput
              #recipientsCCInput
              [matChipInputFor]="recipientsCCChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              [matAutocomplete]="recipientsCCAutoOption"
              [errorStateMatcher]="matcher">
          </mat-chip-grid>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
          <mat-autocomplete #recipientsCCAutoOption (optionSelected)="onUserCCSelected($event)">
            <mat-option *ngFor="let user of autocompleteUserCC$ | async"
                        [class.internalUser]="this.isUserInternal(user)"
                        [class.externalUser]="!this.isUserInternal(user)"
                        [value]="user">
              {{this.isUserInternal(user) ? '(Operator)' : '(Extern)'}} - {{ user.firstname }} {{ user.lastname }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-content">
        <div class="content-header">
          <h4>Betreff</h4>
          <span style="color: #979797; text-align: right;"> {{ currentSubjectContentLength }} / {{ maximumSubjectContentLength }} Zeichen</span>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Ihr Text</mat-label>
          <input
            matInput
            formControlName="subject"
            [maxlength]="maximumSubjectContentLength"
            [errorStateMatcher]="matcher"
            required>
          <mat-hint *ngIf="!validationService.latinLettersAndPunctuationValidator(messageCreationFormGroup.controls.subject.value)">Text/Meldung wird ohne Sonderzeichen gespeichert</mat-hint>
        </mat-form-field>
      </div>

      <div class="field-content">
        <div class="content-header">
          <h4>Information</h4>
          <span style="color: #979797; text-align: right;"> {{ currentMessageContentLength }} / {{ maximumMessageContentLength }} Zeichen</span>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Ihr Text</mat-label>
          <textarea
            matInput
            formControlName="message"
            [maxlength]="maximumMessageContentLength"
            [errorStateMatcher]="matcher"
            rows="6"
            required>
          </textarea>
          <mat-hint *ngIf="!validationService.latinLettersAndPunctuationValidator(messageCreationFormGroup.controls.message.value)">Text/Meldung wird ohne Sonderzeichen gespeichert</mat-hint>
        </mat-form-field>
      </div>

      <div class="field-content">
        <h4>Zu bearbeiten bis</h4>
        <mat-form-field appearance="outline">
          <mat-label>Datum</mat-label>
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <input [min]="nowDate" matInput [matDatepicker]="picker" formControlName="wishResolutionDate" readonly>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class='div-stl' style='padding-bottom: 30px;'>
      <button id='btn1' class='nd-btn nd-btn-outline btn-fnt btn-spc' style='width: 160px;'
              mat-raised-button (click)="onClsBtnClick()"> Abbrechen
      </button>
      <button id='btn2' class='nd-btn nd-btn-main btn-fnt btn-spc' style='width: 220px;'
              mat-raised-button (click)="onConfirm(true)"> Speichern und Mail senden
      </button>
      <button id='btn3' class='nd-btn nd-btn-main btn-fnt btn-spc' style='width: 160px;'
              mat-raised-button (click)="onConfirm(false)"> Nur Speichern
      </button>
    </div>
  </mat-dialog-actions>
</div>
